export const MEASURE_LAYER_ID = "measure-live_layer";
export const MEASURE_SOURCE_ID = "measure-live_source";
export const MEASURE_SAVED_LAYER_ID = "measure-saved_layer";
export const MEASURE_SAVED_SOURCE_ID = "measure-saved_source";
export const MEASURE_FEATURE_KEY = "measure_feature";
export const EDIT_MEASURE_SOURCE_ID = "measure-edit-vertices-source";
export const EDIT_MEASURE_LAYER_ID = "measure-edit_layer";

export const MEASURE_DRAWING_FEATURE_COLOR = "rgba(251, 191, 36, 0.2)";
export const MEASURE_DRAWING_FEATURE_STROKE_COLOR = "rgba(251, 191, 36, 0.5)";
export const MEASURE_DRAWING_FEATURE_STROKE_WIDTH = 2;

export const MEASURE_MODIFY_FEATURE_COLOR = "rgba(255, 255, 0, 0.2)";
export const MEASURE_MODIFY_FEATURE_STROKE_COLOR = "rgba(255, 255, 0, 0.5)";
export const MEASURE_MODIFY_FEATURE_STROKE_WIDTH = 2;

export const MEASURE_FEATURE_COLOR = "rgba(255, 0, 255, 0.7)";
export const MEASURE_FEATURE_STROKE_COLOR = "rgba(255, 0, 255, 1)";
export const MEASURE_FEATURE_STROKE_WIDTH = 2;
